// extracted by mini-css-extract-plugin
module.exports = {"root":"umf1EpiVhvMBzcn06eGh","icon":"kdiNa4ffwCBU51YXbXSv"};